import { render, staticRenderFns } from "./setPopover.vue?vue&type=template&id=9d951f4c&scoped=true&"
import script from "./setPopover.vue?vue&type=script&lang=js&"
export * from "./setPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d951f4c",
  null
  
)

component.options.__file = "setPopover.vue"
export default component.exports